// Enums for types of appointments
export enum AppointmentType {
    REMOTE = "Remote",
    INPERSON = "In-person",
}
// Diagnosis code details
export interface IDiagnosisCode {
    diagnosis_code_id: string;
    code: string;
    description: string;
    created_at: string;
    updated_at: string;
    deprecated?: boolean;
}

// these are all optional because not all tables have these columns
export interface ISortTable {
    date_of_service?: string;
    client?: {
        first_name: string;
        last_name: string;
    };
    first_name?: string;
    provider_name?: string;
    client_name?: string;
    description?: string;
}

// Custom dates type for filtering in app
export enum IAppCustomDates {
    ALL_TIME = "all_time",
    LAST_24_HRS = "last_24_hrs",
    THIS_WEEK = "this_week",
    LAST_WEEK = "last_week",
    LAST_TWO_WEEKS = "last_two_weeks",
    THIS_MONTH = "this_month",
    LAST_MONTH = "last_month",
    LAST_30_DAYS = "last_30_days",
    LAST_60_DAYS = "last_60_days",
    LAST_90_DAYS = "last_90_days",
    LAST_120_DAYS = "last_120_days",
    THIS_YEAR = "this_year",
}

// Enums for session delivery options
export enum RecurrenceRule {
    WEEKLY = "Weekly",
    BIWEEKLY = "Bi-Weekly",
    TRIWEEKLY = "Tri-Weekly",
    MONTHLY = "Monthly",
    ONE_OFF = "One-Off",
    TWO_MONTHS = "Two-Months",
    THREE_MONTHS = "Three-Months",
}

export enum AppSortOrder {
    ASC = "ASC",
    DESC = "DESC",
}

export interface SvgProps {
    /** extra classname for styling svg */
    className?: string;
    /** prop for updating the svg path stroke color */
    stroke?: string;
    /** prop for updating the svg path fill color */
    fill?: string;
    /** prop for adding stroke width */
    strokeWidth?: string;
}

export type ExportPdfType = "statement_of_account" | "session_note";

export interface IExportPdf {
    export_job_id: string;
    pdf_type: ExportPdfType;
    expected_pdf_count?: number;
}

export interface IProviderSessionFilters {
    show_sessions_with_term_notes?: string;
    search_string?: string;
    include_inactive_sessions?: string;
    recurrence_rule?: string;
    show_supervisee_sessions?: string;
    confirmed_start_date_time?: string;
    confirmed_end_date_time?: string;
    session_type?: string;
}

export interface ITelehealthCallParticipants {
    name: string;
    user_id: string;
    role: string;
    status: string;
    id: string;
    updated_at: string;
    session_history_id: string;
}

export interface ComboOption {
    value: string;
    label: string;
}

export enum ScheduleWeekType {
    LAST_WEEK = "last_week",
    THIS_WEEK = "this_week",
    NEXT_WEEK = "next_week",
    NEXT_2_WEEKS = "next_2_weeks",
}

export interface IViewFile {
    url: string;
    document_name: string | null;
    metadata: {
        content_type: string;
    };
}
